// src/components/quizz/QuizIntroModal.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle, XCircle, ListChecks } from "lucide-react";

const steps = [
  {
    title: "Bienvenue dans le Quiz 🎉",
    description:
      "Vous allez commencer le quiz. Lisez attentivement les instructions pour bien jouer.",
    icon: "https://cdn-icons-png.flaticon.com/512/3658/3658753.png", // icône de présentation
  },
  {
    title: "Comment répondre ?",
    description: "Choisissez une réponse parmi les 4 options proposées.",
    icon: "https://cdn-icons-png.flaticon.com/512/2659/2659360.png", // icône choix réponse
  },
  {
    title: "Réponses correctes ✅",
    description: "Si votre réponse est correcte, un emoji vert 😊 s'affichera.",
    icon: "https://cdn-icons-png.flaticon.com/512/190/190411.png", // icône check vert
  },
  {
    title: "Réponses incorrectes ❌",
    description:
      "Si votre réponse est incorrecte, un emoji rouge 😡 apparaîtra.",
    icon: "https://cdn-icons-png.flaticon.com/512/463/463612.png", // icône croix rouge
  },
  {
    title: "Progression",
    description:
      "La barre d’icônes indique combien de questions il reste, vos bonnes réponses et vos erreurs.",
    icon: "https://cdn-icons-png.flaticon.com/512/3600/3600910.png", // icône progression
  },
];

const QuizIntroModal = ({ onStart }) => {
  const [step, setStep] = useState(0);

  const nextStep = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      onStart();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <AnimatePresence mode="wait">
        <motion.div
          key={step}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md text-center"
        >
          <img
            src={steps[step].icon}
            alt="Illustration"
            className="w-24 h-24 mx-auto mb-4"
          />
          <h2 className="text-2xl font-bold mb-2">{steps[step].title}</h2>
          <p className="text-gray-600 mb-6">{steps[step].description}</p>

          {/* Indicateurs */}
          <div className="flex justify-center space-x-2 mb-6">
            {steps.map((_, index) => (
              <span
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index === step ? "bg-[#009688]" : "bg-gray-300"
                }`}
              ></span>
            ))}
          </div>

          <button
            onClick={nextStep}
            className="px-6 py-2 bg-[#009688] text-white font-semibold rounded-full hover:bg-[#1f7169] transition"
          >
            {step < steps.length - 1 ? "Suivant" : "Commencer"}
          </button>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default QuizIntroModal;
